import { motion } from 'framer-motion';
import styled from 'styled-components';

export const ThreeColumnIntroBlockSection = styled.div`
  padding: 50px 0 20px;
  @media (max-width: 575.98px) {
    padding: 50px 0 50px;
  }
  &.isabout-page {
    display: none;
  }

  & a {
    font-weight: 600;
    transition: all 0.3s ease-in-out;

    &:hover {
      text-decoration: underline;
      color: #1b7bdd;
    }
  }
  .getting_heremap {
    margin: 3rem auto;
  }
`;
export const ArticlePart = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 991.98px) {
    display: block;
  }
  &.articlecontent {
    h3 {
      @media (max-width: 1199.98px) {
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 1rem;
      }
      @media (max-width: 991.98px) {
        width: 100%;
        margin-bottom: 1.5rem;
      }
      @media (max-width: 575.98px) {
        font-size: 16px;
        line-height: 30px;
        margin-bottom: 1rem;
      }
    }
  }
`;
export const ArticleH3 = styled.h3`
  width: 30%;
  &[dir='rtl'] {
    font-family: 'GEAwtarDWTCMedium';
  }
  @media (max-width: 991.98px) {
    width: 100%;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 575.98px) {
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 1rem;
  }
`;
export const ArticleParagraph = styled.div`
  width: 66%;
  padding-bottom: 0;
  -webkit-column-count: 2;
  -moz-column-count: 2;
  column-count: 2;
  -webkit-column-gap: 50px;
  -moz-column-gap: 50px;
  column-gap: 50px;
  @media (max-width: 767.98px) {
    display: flex;
    flex-direction: row;
    flex-direction: column;
    webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
  }
  .bullet-list {
    font-style: italic;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;
    color: rgb(137, 137, 137);
    word-spacing: 0px;
    list-style: none;
    margin: 1.3rem 0;
    @media (max-width: 767.98px) {
      margin: 0px;
    }
  }
  p {
    z-index: 1;
    margin: 0px;
    z-index: 1;
    @media (max-width: 767.98px) {
      background: inherit;
    }
  }
  @media (max-width: 991.98px) {
    width: 100%;
  }
`;
export const TextWrapper = styled(motion.p)`
  margin-bottom: 0;
  color: #898989;

  &:last-child {
    margin-top: 1.5rem;
  }
`;

export const ReadMoreLabel = styled.button`
  background-color: transparent;
  background-position: 0% 0%;
  border: none;
  color: #898989;
  cursor: pointer;
  font-size: 14px;
  line-height: 0px;
  text-align: left;
  text-decoration: underline;
  word-spacing: 0px;
  margin-top: 0px;
  margin-bottom: 35px;
  padding: 0px;
  &[dir='ltr'] {
    font-family: 'DINRegular';
  }
  &[dir='rtl'] {
    font-family: GESSTwoDWTCLight, sans-serif;
    color: #898989;
  }
  &:hover {
    color: ${(props) => props.color};
  }
  ${({ toggle }) =>
    toggle
      ? `
      animation-name: fadeDownLabel;
      animation-duration: 800ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `
      : `
      animation-name: fadeUpLabel;
      animation-duration: 800ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `}
  @keyframes fadeUpLabel {
    0% {
      margin-top: 3rem;
    }
    100% {
      margin-top: 0.5rem;
    }
  }
  @keyframes fadeDownLabel {
    0% {
      margin-top: 0.5rem;
    }
    100% {
      margin-top: 3rem;
      color: ${(props) => props.color};
    }
  }
  @media (min-width: 576px) {
    display: none;
    animation: none;
  }
`;
export const FullWidthImage = styled.div`
  padding-top: 80px;
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 992px) {
    padding-top: 40px;
    img {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
  @media (max-width: 557px) {
    padding-top: 20px;
    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
`;
